"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteKeySelector = exports.moduleName = void 0;
/**
 * Constants
 * */
exports.moduleName = 'siteKey';
/**
 * Reducer
 * */
function reducer(state, action) {
    if (state === void 0) { state = ''; }
    var type = action.type;
    switch (type) {
        default:
            return state;
    }
}
exports.default = reducer;
/**
 * Selectors
 * */
var siteKeySelector = function (state) { return state[exports.moduleName]; };
exports.siteKeySelector = siteKeySelector;
/**
 * Action Creators
 * */
